import { CheckCircleOutlined } from '@ant-design/icons';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { ConfirmWidgetConfigComponent } from './ConfirmWidgetConfigComponent.tsx';
import { ConfirmWidgetFormComponent } from './ConfirmWidgetFormComponent.tsx';
import { ConfirmWidgetPreviewComponent } from './ConfirmWidgetPreviewComponent.tsx';
import { ConfirmWidgetSchema } from './ConfirmWidgetSchema.ts';
import { createConfirmWidgetFormSchema } from './createConfirmWidgetFormSchema.ts';
import { getConfirmWidgetReference } from './getConfirmWidgetReference.ts';
import { type IConfirmWidget } from './IConfirmWidget.ts';
import { ConfirmWidgetRequiredRule } from './rules/ConfirmWidgetRequired.rule.ts';

export const ConfirmWidgetType: IWidgetType<IConfirmWidget> = {
  type: WidgetType.Confirm,
  mainType: WidgetMainType.Base,
  category: WidgetCategory.Advanced,
  name: 'Conferma',
  icon: <CheckCircleOutlined />,
  hasValue: true,
  getReference: getConfirmWidgetReference,
  createFormSchema: createConfirmWidgetFormSchema,
  formComponent: ConfirmWidgetFormComponent,
  previewComponent: ConfirmWidgetPreviewComponent,
  configValidator: ConfirmWidgetSchema,
  configComponent: ConfirmWidgetConfigComponent,
  translationSchema: tran.widget({
    layout: tran.object({
      confirmText: tran.string(),
      editText: tran.string(),
    }),
  }),
  rules: [],
  fixedRules: [ConfirmWidgetRequiredRule],
};
